/** One browser tab may choose a brand without changing another tab. */
export function selectionKey(userId: string): string {
  return `aditor-active-brand:${userId}`;
}

export interface MembershipChoice {
  id: string;
}

/** The server's last brand wins after an invite; otherwise retain a valid tab choice. */
export function selectInitialBrand(
  serverBrandId: string,
  savedBrandId: string | null,
  memberships: MembershipChoice[],
  acceptedInvite: boolean,
): string {
  if (acceptedInvite || !savedBrandId) return serverBrandId;
  return memberships.some(m => m.id === savedBrandId) ? savedBrandId : serverBrandId;
}
